import {RouteProps} from 'react-router'
import {Assignment} from '@pages/assignment'
import {ForgotPassword} from '@pages/forgot-password'
import {CreateAccount} from '@pages/create-account'
import {Login} from '@pages/login'
import {NotFound} from '@pages/not-found'
import {Payments} from '@pages/payments'
import {Settings} from '@pages/settings'
import {RouteErrorElement} from '@components/commons/route-error-element'
import {ResetPassword} from '@pages/reset-password'
import {Insights} from '@pages/insights'
import {GoogleAuthCallback} from '@pages/google-auth-callback'
import {Home} from '@pages/home'
import {ChangeEmailVerify} from '@pages/change-email-verify'
import {PublicLanding} from '@pages/public-landing'
import {LinkAirbnbAccount} from '@pages/link-airbnb-account'
import {LinkAirbnbAccountConfirm} from '@pages/link-airbnb-account-confirm'
import {SsoRedirect} from '@pages/sso-redirect'
import {PrivacyPolicy} from '@pages/privacy-policy'
import {MarketsConfiguration} from '@pages/markets-configuration'
import {FloorPlanOptIn} from '@pages/floor-plan-opt-in'

export const routes = {
    ASSIGNMENT: {
        path: 'assignments/:code',
        element: <Assignment />,
        errorElement: <RouteErrorElement />,
        handle: {
            fullPath: '/assignments/:code'
        }
    },
    CREATE_ACCOUNT: {
        path: 'create-account/:token',
        element: <CreateAccount />,
        errorElement: <RouteErrorElement />,
        handle: {
            fullPath: '/create-account/:token'
        }
    },
    HOME: {
        index: true,
        element: <Home />,
        errorElement: <RouteErrorElement />,
        handle: {
            fullPath: '/'
        }
    },
    FORGOT_PASSWORD: {
        path: 'forgot-password',
        element: <ForgotPassword />,
        errorElement: <RouteErrorElement />,
        handle: {
            fullPath: '/forgot-password'
        }
    },
    LOGIN: {
        path: 'login',
        element: <Login />,
        errorElement: <RouteErrorElement />,
        handle: {
            fullPath: '/login'
        }
    },
    NOT_FOUND: {
        path: '*',
        element: <NotFound />,
        errorElement: <RouteErrorElement />
    },
    PAYMENTS: {
        path: 'payments',
        element: <Payments />,
        errorElement: <RouteErrorElement />,
        handle: {
            fullPath: '/payments'
        }
    },
    RESET_PASSWORD: {
        path: 'reset-password/:token',
        element: <ResetPassword />,
        errorElement: <RouteErrorElement />,
        handle: {
            fullPath: '/reset-password/:token'
        }
    },
    SETTINGS: {
        path: 'settings',
        element: <Settings />,
        errorElement: <RouteErrorElement />,
        handle: {
            fullPath: '/settings'
        }
    },
    INSIGHTS: {
        path: 'insights',
        element: <Insights />,
        errorElement: <RouteErrorElement />,
        handle: {
            fullPath: '/insights'
        }
    },
    GOOGLE_AUTH_CALLBACK: {
        path: 'google-auth-callback',
        element: <GoogleAuthCallback />,
        errorElement: <RouteErrorElement />,
        handle: {
            fullPath: '/google-auth-callback'
        }
    },
    CHANGE_EMAIL_VERIFY: {
        path: 'email-verify/:token',
        element: <ChangeEmailVerify />,
        errorElement: <RouteErrorElement />,
        handle: {
            fullPath: '/email-verify/:token'
        }
    },
    PUBLIC_LANDING: {
        path: 'landing',
        element: <PublicLanding />,
        errorElement: <RouteErrorElement />,
        handle: {
            fullPath: 'landing'
        }
    },
    LINK_AIRBNB_ACCOUNT: {
        path: '/user-onboarding',
        element: <LinkAirbnbAccount />,
        errorElement: <RouteErrorElement />,
        handle: {
            fullPath: '/user-onboarding'
        }
    },
    LINK_AIRBNB_ACCOUNT_CONFIRM: {
        path: '/user-onboarding-confirm',
        element: <LinkAirbnbAccountConfirm />,
        errorElement: <RouteErrorElement />,
        handle: {
            fullPath: '/user-onboarding-confirm'
        }
    },
    SSO_REDIRECT: {
        path: '/redirect',
        element: <SsoRedirect />,
        errorElement: <RouteErrorElement />,
        handle: {
            fullPath: '/redirect'
        }
    },
    MARKETS_CONFIGURATION: {
        path: 'markets-configuration',
        element: <MarketsConfiguration />,
        errorElement: <RouteErrorElement />,
        handle: {
            fullPath: '/markets-configuration'
        }
    },
    PRIVACY_POLICY: {
        path: 'privacy-policy',
        element: <PrivacyPolicy />,
        errorElement: <RouteErrorElement />,
        handle: {
            fullPath: '/privacy-policy'
        }
    },
    FLOOR_PLAN_OPT_IN: {
        path: 'floor-plan/opt-in',
        element: <FloorPlanOptIn />,
        errorElement: <RouteErrorElement />,
        handle: {
            fullPath: '/floor-plan/opt-in'
        }
    }
} as const satisfies Record<string, RouteProps>
